import { computed, ref } from "vue";
import { defineStore } from "pinia";

export type Theme = "light" | "dark";

export const useThemeStore = defineStore("theme", () => {
  // State
  const _activeTheme = ref<Theme>("light");

  // Getters
  const activeTheme = computed(() => _activeTheme.value);
  const isDark = computed(() => _activeTheme.value === "dark");
  const isLight = computed(() => _activeTheme.value === "light");

  // Actions
  const setActiveTheme = (theme: Theme) => {
    _activeTheme.value = theme;
  };

  return {
    activeTheme,
    isDark,
    isLight,
    setActiveTheme,
  };
});
